import { useContext, useEffect, useMemo, useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { utilities as utilitiesFunction } from './contactCenterUtilities';
import { LanguageContext } from '../../context/languageContext';
import {
  getDefaultContactCenterPath,
  useAuth,
} from '../../context/authContext';

const getTabIndexFromPath = (pathname, utilities) => {
  const slug = pathname.replace(/^\/contact-center\/?/, '');
  if (!slug) {
    return 0;
  }
  const index = utilities.findIndex(utility => utility.path === slug);
  return index >= 0 ? index : 0;
};

const ContactCenterPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const { accessiblePaths } = useAuth();
  const { translations } = useContext(LanguageContext);
  const utilities = useMemo(
    () => utilitiesFunction(translations),
    [translations],
  );

  useEffect(() => {
    setSelectedTab(getTabIndexFromPath(location.pathname, utilities));
  }, [location.pathname, utilities]);

  if (
    location.pathname === '/contact-center' ||
    location.pathname === '/contact-center/'
  ) {
    return (
      <Navigate to={getDefaultContactCenterPath(accessiblePaths)} replace />
    );
  }

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    const nextPath = utilities[newValue]?.path;
    if (nextPath) {
      navigate(`/contact-center/${nextPath}`);
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'var(--reach-blue)',
          height: '35px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'left',
        }}
      >
        <Typography
          sx={{ color: '#FFFFFF', fontFamily: 'BrightstarSans-Bold', ml: 2 }}
        >
          {translations.agentUtilities || 'Agent Utilities'}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: 'var(--dust-white)',
          minHeight: 'calc(100vh - 35px - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {Array.isArray(utilities) && utilities.length > 0 && (
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            aria-label='Contact Center Tabs'
            indicatorColor='primary'
            textColor='primary'
            sx={{ marginBottom: 2 }}
          >
            {utilities.map((utility, index) => (
              <Tab
                key={utility.path}
                label={utility.tab}
                sx={{ fontFamily: 'BrightstarSans-Regular' }}
              />
            ))}
          </Tabs>
        )}
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: 2,
          }}
        >
          {Array.isArray(utilities) &&
            utilities[selectedTab]?.items.map((item, index) => (
              <Box key={index} sx={{ flexGrow: 1, marginBottom: 2 }}>
                {item.component}
              </Box>
            ))}
        </Box>
      </Box>
    </>
  );
};

export default ContactCenterPage;
